import { SET_ALL_TICKETS_VISIBILITY } from '../types'

export function doShowAllTickets(customerId) {
  return {
    type: SET_ALL_TICKETS_VISIBILITY,
    payload: {
      customerId,
      isVisible: true,
    },
  }
}

export function doHideAllTickets(customerId) {
  return {
    type: SET_ALL_TICKETS_VISIBILITY,
    payload: {
      customerId,
      isVisible: false,
    },
  }
}
